import React, { useEffect, useState } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { createSupabaseClient } from '../infrastructure/services/supabase-client'
import { SupabaseNonnaRepository } from '../infrastructure/services/supabase-nonna-repository'
import { SupabaseAuthService } from '../infrastructure/services/supabase-auth-service'
import AuthView from '../features/auth/views/AuthView'
import HomeView from '../features/home/views/HomeView'
import NonnaProfileView from '../features/nonna-profile/views/NonnaProfileView'
import BookingFlowView from '../features/booking/views/BookingFlowView'
import BookingConfirmedView from '../features/booking-confirmed/views/BookingConfirmedView'
import MyBookingsView from '../features/my-bookings/views/MyBookingsView'
import PaymentsView from '../features/payments/views/PaymentsView'
import AboutView from '../features/about/views/AboutView'
import OnboardingView from '../features/onboarding/views/OnboardingView'
import BottomNav from '../components/shared/BottomNav'
import { theme } from '../core/design-system/theme'

const client = createSupabaseClient()
const repository = new SupabaseNonnaRepository(client)
const authService = new SupabaseAuthService(client)

export default function App() {
  const [hasSeenOnboarding, setHasSeenOnboarding] = useState(
    () => localStorage.getItem('nonna_onboarding_complete') === 'true'
  )
  const [session, setSession] = useState(undefined) // undefined = checking

  function handleOnboardingComplete() {
    localStorage.setItem('nonna_onboarding_complete', 'true')
    setHasSeenOnboarding(true)
  }

  useEffect(() => {
    authService.getSession().then(setSession)
    const sub = authService.onAuthStateChange((s) => setSession(s))
    return () => sub?.unsubscribe()
  }, [])

  if (!hasSeenOnboarding) {
    return <OnboardingView onComplete={handleOnboardingComplete} />
  }

  if (session === undefined) {
    return (
      <div
        style={{
          minHeight: '100vh',
          background: theme.colors.cream,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <span
          style={{
            fontFamily: 'var(--font-display)',
            fontSize: 32,
            color: theme.colors.terracotta,
          }}
        >
          Nonna
        </span>
      </div>
    )
  }

  if (!session) {
    return <AuthView authService={authService} />
  }

  return (
    <BrowserRouter>
      <div style={{ minHeight: '100vh', background: theme.colors.cream, paddingBottom: 64 }}>
        <Routes>
          <Route path="/" element={<HomeView repository={repository} />} />
          <Route path="/nonnas/:id" element={<NonnaProfileView repository={repository} />} />
          <Route path="/book/*" element={<BookingFlowView repository={repository} session={session} />} />
          <Route path="/booking/:id" element={<BookingConfirmedView repository={repository} />} />
          <Route path="/bookings" element={<MyBookingsView repository={repository} session={session} />} />
          <Route path="/payments" element={<PaymentsView repository={repository} session={session} />} />
          <Route path="/about" element={<AboutView repository={repository} />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <BottomNav />
      </div>
    </BrowserRouter>
  )
}
